import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })

export class TaskService {
  private headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
  }

  GetUsers() {
    return this.http.get<any>('UserManagement/GetUsersForFirm', { headers: this.headers });
  }

  GetUsersjob(JobId) {
    return this.http.get<any>('Task/GetUsersjob?JobId=' + JobId );
  }

  GetTaskbudgetList(JobId) {
    return this.http.get<any>('Task/GetTaskbudgetList?JobId=' + JobId);
  }

  GetClients() {
    return this.http.get<any>('client/GetClientList?searchTxt=', { headers: this.headers });
  }

  GetJobs() {
    return this.http.get<any>('Job/GetJobs', { headers: this.headers });
  }

  AddAssignees(task:any){
    return this.http.post<any>('Task/AddEditTemplateTask', task, { headers: this.headers });
  }

  GetTaskDetails(templateId){
    return this.http.get<any>('Task/GetAllTemplateTaskGroupbyId',templateId);
  }

  AddOrUpdateTask(task) {
    return this.http.post<any>('Task/AddEditTasks', task, { headers: this.headers });
  }

  UpdateTaskAssignee(task) {
    return this.http.post<any>('Task/UpdateTaskAssignee', task, { headers: this.headers });
  }

  UpdateTaskRole(task){
    return this.http.post<any>('Task/UpdateTaskRole', task, { headers: this.headers });
  }

  GetTasks() {
    return this.http.get<any>('Task/GetTaskList', { headers: this.headers });
  }

  GetTaskList(JobId, isArchive, currentDate) {
    return this.http.get<any>('Task/GetTaskList?JobId=' + JobId + '&isArchive=' + isArchive + '&currentDate=' + currentDate)
  }

  GetArchiveOrUnArchiveTasks(isArchive) {
    return this.http.get<any>('Task/GetArchiveOrUnArchiveTasks?isArchive=' + isArchive, { headers: this.headers });
  }

  GetTaskDetail(taskId) {
    return this.http.get<any>('Task/GetTaskDetail/' + taskId + '', { headers: this.headers })
  }

  AddNewTask(task) {
    return this.http.post<any>('Task/AddNewTasks', task, { headers: this.headers });
  }

  AddNewTemplateTask(task) {
    return this.http.post<any>('Task/AddNewTemplateTasks', task, { headers: this.headers });
  }

  ArchiveTask(taskId) {
    return this.http.get<any>('Task/ArchiveTask/' + taskId + '', { headers: this.headers });
  }

  GetLinkedPartner() {
    return this.http.get('Client/GetAllPartners', { headers: this.headers })
  }

  GetClientForPartner(userId, entityId) {
    return this.http.get('Client/GetAllClientBypartners?userId=' + userId + '&entityId=' + entityId + '', { headers: this.headers })
  }

  GetTaskDetailById(taskId) {
    return this.http.get<any>('Task/GetTaskDetailById/' + taskId + '', { headers: this.headers })
  }

  UpdateTaskstatus(id, type) {
    return this.http.post<any>('Task/UpdateTaskstatus?id='+ id + '&type='+ type, { headers: this.headers });
  }

  UpdateTaskUsers(request){
    return this.http.post<any>('Task/UpdateTaskUsers', request, { headers: this.headers });
  }

  AddEditJobTaskGroup(TaskGroup) {
    return this.http.post<any>('Job/AddEditJobTaskGroup', TaskGroup, { headers: this.headers });
  }

  GetAllJobTaskGroupbyJobId(JobId, taskCategory=1) {
    return this.http.get<any>('Job/GetAllJobTaskGroupbyJobId?jobId=' + JobId + '&taskCategory=' + taskCategory);
  }

  AddEditJobTaskBreakdown(estimateModel) {
    return this.http.post<any>('Job/AddEditJobTaskBreakdown', estimateModel, { headers: this.headers });
  }

  PostTaskSequences(path: string, data) {
    return this.http.post<any[]>(path, data, { headers: this.headers });
  }

  GetclientId(jobId) {
    return this.http.get('Job/getclientId?JobId=' + jobId , { headers: this.headers })
  }

  getJobDataForTask(JobId) {
    return this.http.get<any>('Job/GetJobDetailsForTask?JobId=' + JobId);
  }

  getAffectedTemplateTaskCount(templateId, taskId, dueAfterDays, mode){
    return this.http.get<any>('task/GetAffectedTemplateTaskCount/'+ templateId + '/' +  taskId + '/' + dueAfterDays + '/' + mode);
  }

  deleteTaskGroupById(id) {
    return this.http.post('Task/DeleteTaskGroupTemplate?taskgroupId='+ id + '', {});
  }

  AddNewTasks(task) {
    return this.http.post<any>('Task/AddMultipleTasksTemplate', task);
  }

  bulkAddEditTask(data){
    return this.http.post<any>('Task/PostBulkAddEditTask', data, { headers: this.headers });
  }

  postBulkAddEditTaskNew(requestBody: any) {
    return this.http.post<any>(
      'Task/PostBulkAddEditTaskNew',
      requestBody,
      { headers : this.headers }
    );
  }

  postAddEditTaskNew(requestBody: any) {
    return this.http.post<any>(
      'Task/PostAddEditTaskNew',
      requestBody,
      { headers : this.headers }
    );
  }

}
